import axios from "axios";
import toast from "react-hot-toast";
import { useMatches } from "react-router-dom";
import dayjs from "dayjs";
export const combineClasses = (...classes) => {
  return classes.join(" ");
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const getProjectId = () => {
  const match = window.location.pathname.match(/project\/(\d+)/);

  if (match && match[1]) {
    return match[1];
  }

  return null;

  // const stored = localStorage.getItem("projectId");
  // try {
  //   return stored ? JSON.parse(stored) : stored;
  // } catch (err) {
  //   console.error("Error parsing projectId from localStorage:", err);
  //   return stored;
  // }
};

export const resolveProjectPath = (pathTemplate, projectId) => {
  return pathTemplate.replace(":projectId", projectId);
};

export const getProjectKey = () => {
  return localStorage.getItem("projectKey");
};

export const getProjectName = () => {
  return localStorage.getItem("projectName");
};

export const getProjectIcon = () => {
  return localStorage.getItem("projectIcon");
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const getUserName = () => {
  return localStorage.getItem("username");
};

export const getUserId = () => {
  return localStorage.getItem("userId");
};

export const getUserProfileUrl = () => {
  return localStorage.getItem("profileUrl");
};

export const getUserProfileColor = () => {
  return localStorage.getItem("profileColour");
};

export const onlyNumbersInput = (e) => {
  ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
};

export const getColor = () => {
  function hslToHex(h, s, l) {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, "0"); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  }
  return hslToHex(
    360 * Math.random(),
    25 + 70 * Math.random(),
    85 + 10 * Math.random(),
  );
};

export const getPdfPreviewUrl = async (setUrl, url) => {
  if (url) {
    try {
      const res = await axios.get(url, {
        responseType: "blob",
      });
      const previewUrl = URL.createObjectURL(res?.data);
      setUrl(previewUrl);
    } catch (error) {
      toast.error(error?.message);
    }
  }
};

export const strSplitFunc = (str, length = 30) => {
  const newStr = `${str.split("").slice(0, length).join("")}...`;
  return newStr;
};

export const dateConverter = (str) => {
  // const date = str.toString().split(" ");
  // return [months[date[1]], date[3]].join("/");
  const d = new Date(str);
  let mm = d.getMonth() + 1;
  let dd = d.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    d.getFullYear(),
  ].join("/");
};
export const dateTimeConverter = (value) => {
  if (!value) return "-";
  const d = dayjs(value);

  return d.isValid() ? d.format("DD MMM YYYY, hh:mm A") : "-";
};
export const convert = (dateStr) => {
  if (!dateStr) return new Date();
  if (dateStr instanceof Date) return dateStr;

  if (typeof dateStr === "string" && dateStr.includes("-")) {
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  }

  return new Date(dateStr);
};

export const capitalize = (str) => {
  if (typeof str !== "string" || !str.trim()) {
    return str;
  }

  const words = str.split(" ");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );

  return capitalizedWords.join(" ");
};
export const getColorFromString = (stageName = "") => {
  const name = stageName.toUpperCase();
  if (
    name.includes("TODO") ||
    name.includes("TO DO") ||
    name.includes("OPEN")
  ) {
    return "#22c55e";
  }

  if (
    name.includes("IN PROGRESS") ||
    name.includes("PROGRESS") ||
    name.includes("WORK")
  ) {
    return "#f59e0b";
  }

  if (
    name.includes("REVIEW") ||
    name.includes("QA") ||
    name.includes("VERIFY")
  ) {
    return "#3b82f6";
  }

  if (
    name.includes("BLOCKED") ||
    name.includes("HOLD") ||
    name.includes("WAIT")
  ) {
    return "#ef4444";
  }

  if (
    name.includes("DONE") ||
    name.includes("COMPLETE") ||
    name.includes("CLOSED")
  ) {
    return "#16a34a";
  }

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 60%, 55%)`;
};

export const useRouteMetadata = (prop) => {
  const matches = useMatches();
  // Loop through the matches and find the relevant metadata (like permissionName)
  const route = matches[matches.length - 1]; // Get the last matched route
  return route?.handle && route?.handle[prop]; // Assuming permissionName is stored in handle
};

export const getInitials = (name) =>
  name
    ?.split(" ")
    ?.map((name) => name[0].toUpperCase())
    ?.join("");

export const conditionalColumn = (condition, column) => {
  return condition ? [column] : [];
};

export function getContrastColor(hex) {
  hex = hex.replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.6 ? "#000000" : "#FFFFFF";
}

// New utility function to clean and determine if a link is external
export const formatLinkText = (link) => {
  const isExternal = /^https?:\/\//.test(link);
  let cleanedText = link;

  if (isExternal) {
    // Remove protocol, www, and trailing slashes for a cleaner display
    cleanedText = cleanedText
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .replace(/\/$/, "");
  }

  return { cleanedText, isExternal };
};

export const createEnum = (obj) => {
  Object.freeze(obj);
};
// export const template_type = "Support"

export const formatToMonthDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

export const toTitleCase = (text) => {
  if (!text) return "";

  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const LocalDateTimeConverter = (date) => {
  return new Date(date + "Z").toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
    .replace("am", "AM")
    .replace("pm", "PM");
};